import { readPickerRecent, rememberPickerRecent } from '@atoms/PickerCombobox/pickerRecent';

// у справочника 3 недавних на справочник, здесь — общие на все поля: людей в работе больше
const RECENT_LIMIT = 5;

const abookRecentStorageKey = (username: string) => `user-${username}.abookpickerRecent`;

/**
 * Ключи адресной книги, выбранные последними (новые первыми), — общие для всех полей: в выпадающем списке
 * показываются те, что проходят условия его вкладки.
 */
export const readAbookRecentKeys = (username: string): string[] =>
    readPickerRecent(abookRecentStorageKey(username), RECENT_LIMIT);

export const rememberAbookRecentKeys = (username: string, keys: string[]) =>
    rememberPickerRecent(abookRecentStorageKey(username), keys, RECENT_LIMIT);
